import { Injectable } from '@angular/core';
import { EdgeCollection, EdgeSingular, NodeSingular, SingularElementArgument } from 'cytoscape';

import { AvancementCodeEnum } from '@connect-services/client/components/synoptic/synoptic-graph/graph-core/synoptic-graph.model';
import { SelectedNode } from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.models';

@Injectable({
    providedIn: 'root',
})
export class SynopticPlanLayoutService {
    public applyStatusClass(styleSheet: CSSStyleSheet, rawNode: NodeSingular): void {
        if (!styleSheet || !rawNode) {
            return;
        }

        const toCreateEdges = this.getConnectedToCreateEdges(rawNode);
        toCreateEdges.forEach((edgeKey) => {
            styleSheet.insertRule(`.boxPlan__cable__${edgeKey} {background: #edb349}`);
            styleSheet.insertRule(`.boxPlan__cable__${edgeKey} p {color: #374756}`);
            styleSheet.insertRule(`.boxPlan__cable__${edgeKey} p span {color: #1f2f3c}`);
        });
    }

    public getConnectedToCreateEdges(rawNode: NodeSingular): string[] {
        const rawEdges: EdgeCollection = rawNode.connectedEdges();

        return rawEdges
            .filter((edge: EdgeSingular) => edge.data().status === AvancementCodeEnum.ToCreate)
            .map((edge: SingularElementArgument) => edge.data().id);
    }

    public prepareNode(rawNode: NodeSingular): SelectedNode {
        return { dataNode: rawNode.data(), rawNode: rawNode };
    }
}
